import { fontSize, theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { spacing, text } = theme;

export const madeToOrder = css`
  position: relative;
  display: flex;
  justify-content: left;
  gap: ${spacing.base}px;
  margin-top: ${spacing.xs}px;
  ${fontSize(text.BODY.XS)}

  [data-testid='tooltip-container'] {
    position: static;
  }
`;

export const madeToOrderLabel = css`
  ${fontSize(text.BODY.XS)}
  margin: 0;
`;

export const tooltipInfo = css`
  cursor: help;
  display: grid;
  grid-template-columns: 1fr ${spacing.md}px;
  place-items: center;
  font-size: ${text.BODY.XS.fontSize}px;
`;

export const tooltipInfoIcon = css`
  display: block;
  height: ${spacing.md}px;
  width: ${spacing.md}px;
  margin: 0 0 0 ${spacing.base}px;
`;
